angular.module('angus.controllers').directive('rider', function() {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'templates/tankMonitor/inventoryManagement/rider/riderView.html'
    };
});
  